import { tokens } from "../../../../theme";
import { Box, Typography, useTheme } from "@mui/material";
import { Error as ErrorIcon } from "@mui/icons-material";
import { refreshDrawerStyles } from "./styles";
import TargetSelect from "./TargetSelect";
import ScopeCard from "./ScopeCard";

const StandardPanel = ({
  env,
  labels,
  releaseLabel,
  setReleaseLabel,
  scope,
  setScope,
  baseConfigBranch,
  setBaseConfigBranch,
}) => {
  const theme = useTheme();
  const { refreshDrawer } = refreshDrawerStyles(tokens(theme.paletteId));
  return (
    <>
      <TargetSelect
        title={null}
        label="Refresh to"
        labels={labels}
        releaseLabel={releaseLabel}
        setReleaseLabel={setReleaseLabel}
        helper="Services, UI and seed data are taken from this label."
        scope={scope}
        setScope={setScope}
        baseConfigBranch={baseConfigBranch}
        setBaseConfigBranch={setBaseConfigBranch}
      />
      <ScopeCard
        title="What gets refreshed"
        description="Defaults match the old one-click Confirm. Uncheck to narrow the run."
        variant="checklist"
        scope={scope}
        setScope={setScope}
      />
      <Box sx={refreshDrawer.calloutWarn}>
        <ErrorIcon sx={refreshDrawer.calloutWarnIcon} />
        <Typography component="span" sx={refreshDrawer.reviewWarnText}>
          Databases and tenants are preserved. Pods restart in place, so
          in-flight test runs against{" "}
          <Box component="span" sx={refreshDrawer.calloutWarnMono}>
            {env?.name || "this environment"}
          </Box>{" "}
          will fail while the rollout completes.
        </Typography>
      </Box>
    </>
  );
};

export default StandardPanel;
